import React from "react";
import styled from "styled-components";

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SkeletonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  gap: 12px;

  &:last-child {
    border-bottom: none;
  }

  &.total {
    border-top: 2px solid #eee;
    border-bottom: 2px solid #eee;
    padding: 15px 0;
    margin: 15px 0;
  }
`;

const SkeletonLine = styled.div`
  height: 12px;
  background: #ddd;
  border-radius: 4px;
  animation: shimmer 1.5s ease-in-out infinite;
  flex: ${(props) => props.flex || 1};

  @keyframes shimmer {
    0% {
      background: #ddd;
    }
    50% {
      background: #e8e8e8;
    }
    100% {
      background: #ddd;
    }
  }
`;

const OrderSummarySkeleton = ({ itemCount = 3 }) => {
  return (
    <SkeletonWrapper>
      {/* Cart Items Skeleton */}
      {Array.from({ length: itemCount }).map((_, index) => (
        <SkeletonItem key={index}>
          <SkeletonLine flex={2} />
          <SkeletonLine flex={0.8} />
        </SkeletonItem>
      ))}

      {/* Subtotal Skeleton */}
      <SkeletonItem>
        <SkeletonLine flex={1} />
        <SkeletonLine flex={0.6} />
      </SkeletonItem>

      {/* Shipping Skeleton */}
      <SkeletonItem>
        <SkeletonLine flex={1} />
        <SkeletonLine flex={0.6} />
      </SkeletonItem>

      {/* Shipping Note Skeleton */}
      <SkeletonItem>
        <SkeletonLine flex={1} style={{ height: "10px" }} />
      </SkeletonItem>

      {/* Total Skeleton */}
      <SkeletonItem className="total">
        <SkeletonLine flex={1} />
        <SkeletonLine flex={0.6} />
      </SkeletonItem>
    </SkeletonWrapper>
  );
};

export default OrderSummarySkeleton;
